import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createBlock as _createBlock, toDisplayString as _toDisplayString, createVNode as _createVNode, createCommentVNode as _createCommentVNode, withModifiers as _withModifiers, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
const _withId = /*#__PURE__*/_withScopeId("data-v-4713f3b4")

_pushScopeId("data-v-4713f3b4")
const _hoisted_1 = { class: "special-item-title" }
const _hoisted_2 = { class: "special-item-content-wrapper" }
const _hoisted_3 = { class: "special-item-title" }
const _hoisted_4 = { class: "special-item-content-wrapper" }
_popScopeId()

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  return (_openBlock(), _createBlock("div", null, [
    (_ctx.data.special == 1)
      ? (_openBlock(), _createBlock("div", {
          key: 0,
          class: `special-wrapper special-${_ctx.data.special}`
        }, [
          (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.data.info.list, (i, k) => {
            return (_openBlock(), _createBlock("div", {
              class: "special-item",
              key: k
            }, [
              _createVNode("div", _hoisted_1, [
                _createVNode("span", null, _toDisplayString(i.title), 1)
              ]),
              _createVNode("div", _hoisted_2, [
                (_openBlock(true), _createBlock(_Fragment, null, _renderList(i.intro, (m, n) => {
                  return (_openBlock(), _createBlock("div", {
                    class: "special-item-content-item",
                    key: n
                  }, [
                    (m.icon)
                      ? (_openBlock(), _createBlock("img", {
                          key: 0,
                          src: m.icon
                        }, null, 8, ["src"]))
                      : _createCommentVNode("", true),
                    _createVNode("p", null, _toDisplayString(m.value), 1)
                  ]))
                }), 128))
              ])
            ]))
          }), 128))
        ], 2))
      : (_ctx.data.special == 2)
        ? (_openBlock(), _createBlock("div", {
            key: 1,
            class: `special-wrapper special-${_ctx.data.special}`,
            onClick: _cache[1] || (_cache[1] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.goUrl && _ctx.goUrl(...args)), ["stop","prevent"]))
          }, [
            _createVNode("div", _hoisted_3, [
              _createVNode("span", null, _toDisplayString(_ctx.data.info.title), 1)
            ]),
            _createVNode("div", _hoisted_4, [
              (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.data.info.intro, (m, n) => {
                return (_openBlock(), _createBlock("div", {
                  class: "special-item-content-item",
                  key: n
                }, [
                  _createVNode("p", null, _toDisplayString(m.value), 1)
                ]))
              }), 128))
            ]),
            _createVNode("img", {
              src: _ctx.data.info.img
            }, null, 8, ["src"])
          ], 2))
        : _createCommentVNode("", true)
  ]))
})